<template>
  <div>
    <v-layout class="backgroundCard pa-2 caption">
      Quote {{ item.id }}
      <v-spacer></v-spacer>
      <c-price :quantity="amountDue" labelMode :currency="item.currency">
      </c-price>
    </v-layout>
    <div class="c-hr"></div>
    <div class="pa-3">
      <template v-if="item.items.length > 0">
        <v-layout v-for="quote_item in item.items" :key="quote_item.id" class="caption mb-2">
          <img class="c-align-self-start" src="@/assets/img/illustrations/purse.png" alt="cardboard box" width="25px">
          <div>
            <div class="text-ellipsed">
              <template v-if="quote_item.json_data">
                {{ quote_item.json_data.name }}
              </template>
              <template v-else>
                {{ quote_item.definition.name }}
              </template>
            </div>

            <div>
              <c-ms-ii
              :metric_definition="quote_item.definition" 
              :realValue="quote_item.quantity"
              :key="'c' + (quote_item.definition || {}).id"
              class="font-weight-bold"
              labelMode
              ></c-ms-ii>
              ||
              <c-price 
              :quantity="quote_item.total_cost" 
              :currency="item.currency" 
              labelMode>
              </c-price>
            </div>

          </div>
        </v-layout>
      </template>
      <template v-else>
        <span class="caption">
          No items
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import {BigNumber} from 'bignumber.js'

export default {
  props: {
    item: null
  },
  computed: {
    netTotalCostSum () {
      return this.item.items.reduce((a, i) => {
        return a + i.total_cost
      }, 0)
    },
    netDiscount () {
      return this.item.items.reduce((a, i) => {
        var discount = new BigNumber(i.discount || 0).dividedBy(100)
        return a + (i.total_cost * discount)
      }, 0)
    },
    subtotalMinusDiscount () {
      return this.netTotalCostSum - this.netDiscount
    },
    totalVAT () {
      var percent = Number(this.item.tax) / 100
      return this.subtotalMinusDiscount * percent
    },
    amountDue () {
      return this.subtotalMinusDiscount + this.totalVAT - this.item.paid
    },
  }
}
</script>